export const getRoundParams = (state, props) => state.round;
